<div class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">

	<ms-page-title />

	<ul class="nav nav-tabs reports-tabs mb-3">
		@for (tab of tabs; track tab.path) {
			<li class="nav-item">
				<a class="nav-link reports-tab-link"
					[routerLink]="[tab.path]"
					[routerLinkActive]="'active'"
					[attr.aria-describedby]="tab.path === activeTab()?.path ? descriptionElementId : null">
					<fa-duotone-icon [icon]="tab.icon" class="me-2" />
					<span class="reports-tab-label">{{ tab.label }}</span>
				</a>
			</li>
		}
	</ul>

	@if (activeTab(); as tab) {
		<p class="reports-tab-description mb-4" [id]="descriptionElementId">{{ tab.description }}</p>
	}

	<router-outlet />
</div>
